import React, { Component } from "react";
import { Modal, message, Spin, Typography, Alert } from "antd";
import axios from "axios";
import { Form, FormItem, InputItem, ButtonItem } from "../../../../Components/Items";


const { Text } = Typography;

class ModalEliminar extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    textoConfirmacion: "",
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ textoConfirmacion: "" });
      if (this.formRef.current) this.formRef.current.resetFields();
    }
  }

  handleEliminar = async () => {
    const { tipoEliminar, itemEliminarId } = this.props;
    
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "permisos/eliminarItem",
        { itemId: itemEliminarId, tipo: tipoEliminar },
        { headers: this.props.headersToken }
      );

      if (res.data.success) {
        message.success(res.data.message);
        this.props.onSuccess(tipoEliminar);
      } else {
        message.error(res.data.message || "Error al eliminar");
      }
    } catch (error) {
      console.error(error);
      message.error("Ocurrió un error de conexión al eliminar.");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { visible, onCancel, tipoEliminar } = this.props;
    const { textoConfirmacion, loading } = this.state;
    

    const puedeEliminar = textoConfirmacion === "ELIMINAR";

    let mensajeAlerta = "";
    if (tipoEliminar === "grupo") {
      mensajeAlerta = "Esta acción eliminará el grupo, TODOS sus subgrupos y TODOS los permisos que contengan. Esta acción es permanente e irreversible.";
    } else if (tipoEliminar === "subgrupo") {
      mensajeAlerta = "Esta acción eliminará el subgrupo y TODOS los permisos que contiene. Esta acción es permanente e irreversible.";
    } else {
      mensajeAlerta = "Esta acción eliminará el permiso de forma permanente e irreversible.";
    }

    return (
      <Modal
        title={
          <span style={{ color: "#ff4d4f" }}>
            Eliminar {tipoEliminar ? tipoEliminar.toUpperCase() : ""}
          </span>
        }
        visible={visible}
        onCancel={onCancel}
        footer={null}
        destroyOnClose
      >
        <Spin spinning={loading}>
          <Alert
            message="¡Advertencia de Eliminación en Cascada!"
            description={mensajeAlerta}
            type="error"
            showIcon
            style={{ marginBottom: 20 }}
          />

          <div style={{ marginBottom: 15 }}>
            <Text>
              Para confirmar que deseas borrar este registro, por favor escribe la palabra{" "}
              <strong style={{ color: "#ff4d4f" }}>ELIMINAR</strong> en el siguiente recuadro:
            </Text>
          </div>

          <Form ref={this.formRef} layout="vertical" onFinish={this.handleEliminar}>
            <FormItem name="confirmacion">
              <InputItem 
                placeholder="Escribe ELIMINAR" 
                onChange={(e) => this.setState({ textoConfirmacion: e.target.value })}
                autoComplete="off"
              />
            </FormItem>

            <ButtonItem
              type="primary"
              danger 
              htmlType="submit"
              disabled={!puedeEliminar}
              style={{ width: "100%", marginTop: 10 }}
            >
              Sí, entiendo las consecuencias, eliminar {tipoEliminar}
            </ButtonItem>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

export default ModalEliminar;